import { Tabs as HeroUiTabs } from '@heroui/tabs';

export const Tabs = HeroUiTabs;
